import React, { Fragment } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { ACL } from '../../../../../../../config/constants/UogACL/ACL';

function ManagePermission(props) {
  const {
    index,
    item,
    showIcon,
    addPermissionToGroup,
    removePermissionFromGroup,
    displayPermissionsGroup,
    permissionType
  } = props;

  if (!ACL.ADMIN.GROUPS.SYNC_ACLS.hasAccess()) {
    return null;
  }

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={
              displayPermissionsGroup ?
              `remove-${permissionType}-permission-from-group-${index}` :
              `add-${permissionType}-permission-from-group-${index}`
            }
            onClick={e => {
              e.preventDefault();
              displayPermissionsGroup ?
              removePermissionFromGroup(item, index) :
              addPermissionToGroup(item, index);
            }}
          >
            {
              displayPermissionsGroup ?
              <FormattedMessage id="components.pages.admin.tabs.permissions_list.actionButtons.remove_permission"/> :
              <FormattedMessage id="components.pages.admin.tabs.permissions_list.actionButtons.add_permission"/>
            }
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={
              displayPermissionsGroup ?
              `remove-${permissionType}-permission-from-group-${index}` :
              `add-${permissionType}-permission-from-group-${index}`
            }
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            {
              displayPermissionsGroup ?
              <FormattedMessage id="components.pages.admin.tabs.permissions_list.actionButtons.remove_permission"/> :
              <FormattedMessage id="components.pages.admin.tabs.permissions_list.actionButtons.add_permission"/>
            }
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={
              displayPermissionsGroup ?
              `remove-${permissionType}-permission-from-group-${index}` :
              `add-${permissionType}-permission-from-group-${index}`
            }
            onClick={e => {
                e.preventDefault();
                displayPermissionsGroup ?
                removePermissionFromGroup(item, index) :
                addPermissionToGroup(item, index);
            }}
          >
            <FontAwesomeIcon
              size="lg"
              className="align-middle cursor-pointer"
              pointerEvents="none"
              icon={displayPermissionsGroup ? faMinusCircle : faPlusCircle}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={
              displayPermissionsGroup ?
              `remove-${permissionType}-permission-from-group-${index}` :
              `add-${permissionType}-permission-from-group-${index}`
            }
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            {
              displayPermissionsGroup ?
              <FormattedMessage id="components.pages.admin.tabs.permissions_list.actionButtons.remove_permission"/> :
              <FormattedMessage id="components.pages.admin.tabs.permissions_list.actionButtons.add_permission"/>
            }
          </UncontrolledTooltip>
        </Fragment>
      }
    </Fragment>
  );
}

export { ManagePermission };
